<template>
  <!-- -->
  <yq-table :data="dataList" height="100%" stripe border v-if="level === 1"  page-name="otherAttendance1">
    <yq-table-column label="项目" prop="projectName"/>
    <yq-table-column label="工地" prop="siteName"/>
    <yq-table-column label="施工班组" prop="classmateName"/>
    <yq-table-column label="标段" prop="lotName"/>
    <yq-table-column label="人员总数" prop="resultTotal">
      <template v-slot="{row}"><span :class="row.resultNormal !== row.resultTotal? 'error-status': ''">{{ row.resultTotal }}</span></template>
    </yq-table-column>
    <yq-table-column label="打卡次数" prop="resultNormal">
      <template v-slot="{row}"><span :class="row.resultNormal !== row.resultTotal? 'error-status': ''">{{ row.resultNormal }}</span></template>
    </yq-table-column>
    <yq-table-column label="操作" prop="option" align="center">
      <template v-slot="{row}">
        <table-button-group>
          <table-button hasPerm="laborers:attendance:query" el-type="primary" @click="toDetail(row)">查看</table-button>
        </table-button-group>
      </template>
    </yq-table-column>
  </yq-table>
  <yq-table :data="dataList" height="100%" stripe border v-else-if="level === 2" page-name="otherAttendance2">
    <yq-table-column label="项目" prop="projectName"/>
    <yq-table-column label="工地" prop="siteName"/>
    <yq-table-column label="施工班组" prop="classmateName"/>
    <yq-table-column label="标段" prop="lotName"/>
    <yq-table-column label="人员姓名" prop="workersName">
      <template v-slot="{row}"><span :class="row.attendanceResult !== 1? 'error-status': ''">{{ row.workersName }}</span></template>
    </yq-table-column>
    <yq-table-column label="打卡记录" prop="resultNormal">
      <template v-slot="{row}"><span :class="row.attendanceResult !== 1? 'error-status': ''">{{ row.attendanceResult === 1? '正常': '缺卡' }}</span></template>
    </yq-table-column>
    <yq-table-column label="操作" prop="option" align="center">
      <template v-slot="{row}">
        <table-button-group>
          <table-button hasPerm="laborers:attendance:query" el-type="primary" @click="toDetail(row)">查看</table-button>
        </table-button-group>
      </template>
    </yq-table-column>
  </yq-table>
  <yq-table :data="dataList" height="100%" stripe border v-else-if="level === 3"  empty-text="该人员未进行打卡" page-name="otherAttendance3">
    <yq-table-column label="项目" prop="projectName">
      <template v-slot="{}">{{currentData.projectName}}</template>
    </yq-table-column>
    <yq-table-column label="工地" prop="siteName">
      <template v-slot="{}">{{currentData.siteName}}</template>
    </yq-table-column>
    <yq-table-column label="施工班组" prop="classmateName">
      <template v-slot="{}">{{currentData.classmateName}}</template>
    </yq-table-column>
    <yq-table-column label="劳务人员" prop="type">
      <template v-slot="{}">{{currentData.workersName}}</template>
    </yq-table-column>
    <yq-table-column label="实际打卡时间" prop="realTime"/>
    <yq-table-column label="考勤方式" prop="attendanceType">
      <template v-slot="{row}">
        <el-tag v-if="row.attendanceType === 1" type="success">设备打卡</el-tag>
        <el-tag v-if="row.attendanceType === 2" type="danger">补卡</el-tag>
      </template>
    </yq-table-column>
    <yq-table-column label="考勤类型" prop="checkType">
      <template v-slot="{row}">
        <el-tag v-if="row.checkType === 'IN'" type="primary">上班</el-tag>
        <el-tag v-if="row.checkType === 'OUT'" type="primary">下班</el-tag>
        <el-tag v-if="row.checkType === 'SAFE'" type="primary">安全教育</el-tag>
      </template>
    </yq-table-column>
  </yq-table>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import TableButton from "@/components/h5/button/TableButton.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";

export default {
  props: {
    currentData: {default: () => {}},
    dataList: {default: () => []},
    level: {default: 0}
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "LAW",
  components: {
    TableButtonGroup, YqTableColumn, TableButton
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {
    toDetail(data) {
      this.$emit("toDetail", data);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "attandenceResult";
</style>